import { Resolve, ActivatedRouteSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class CommunityResolver implements Resolve<any> {
  constructor(private httpClient: HttpClient, private router: Router) {}

  async resolve(route: ActivatedRouteSnapshot) {
    const comminityId = parseInt(route.params.id);
    const promises = [this.httpClient.get<any>(`${environment.serverPath}/general/isInvited/community/${comminityId}`).toPromise(),
      this.httpClient.get<any>(`${environment.serverPath}/communities/get-community/${comminityId}`).toPromise()];
    const resolvedPromises = await Promise.all(promises);
    if(!resolvedPromises[1].userCommunity) {

      this.router.navigate(["/communities"]);
    }
    return resolvedPromises;
  }
}
